export const setRefreshTokenAction = 'setRefreshToken';
export const signOutAction = 'signOut';
